import { commandCenterLoansApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

import { CommandCenterLoadKey, markCommandCenterLoadedAction } from './loadStatus.actions';

const SKIP_FORBIDDEN_CONFIG = { skipResponseInterceptor: { forbiddenError: true } };

export const COMMAND_CENTER_DISCLOSURE_TIMING_ACTION_TYPE = createNamedActions(
  'commandCenterDisclosureTiming',
  {
    SET_DISCLOSURE_TIMING: 'SET_DISCLOSURE_TIMING',
  },
);

const fetchSafe = async request => {
  try {
    const { data } = await request();

    return data ?? null;
  } catch {
    return null;
  }
};

export const getCommandCenterDisclosureTimingAction = catchAsyncActionError(
  () => async dispatch => {
    try {
      const data = await fetchSafe(() =>
        commandCenterLoansApi.getDisclosureTiming({ config: SKIP_FORBIDDEN_CONFIG }),
      );

      dispatch({
        type: COMMAND_CENTER_DISCLOSURE_TIMING_ACTION_TYPE.SET_DISCLOSURE_TIMING,
        payload: data,
      });
    } finally {
      // In a `finally` so the slice is marked loaded even when a swallowed 403/404
      // degrades to null — otherwise the zone skeleton never clears (DEV-4174).
      dispatch(markCommandCenterLoadedAction(CommandCenterLoadKey.DISCLOSURE_TIMING));
    }
  },
);
